import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-bc3b8e74")

_pushScopeId("data-v-bc3b8e74")
const _hoisted_1 = { class: "p-field p-col-6 p-mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "p-inputgroup p-mt-3"
}
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { class: "kn-material-input-label" }
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "pi pi-bars p-mr-2" }, null, -1)
const _hoisted_6 = { class: "p-ml-auto" }
const _hoisted_7 = { class: "p-field p-col-6 p-mb-3" }
const _hoisted_8 = {
  key: 0,
  class: "p-d-flex p-p-3 card"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fa fa-link" }, null, -1)
const _hoisted_10 = { class: "p-ml-auto" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Message = _resolveComponent("Message")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Listbox = _resolveComponent("Listbox")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Message, { class: "p-col-12 p-mb-3" }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('managers.crossNavigationManagement.hintDrag')), 1)
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.crossNavigationManagement.availableIO')), 1)
        ]),
        _: 1
      }),
      (_ctx.navigation.fromPars)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("span", _hoisted_3, [
              _createVNode(_component_InputText, {
                class: "kn-material-input",
                type: "text",
                modelValue: _ctx.fixedValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fixedValue = $event)),
                modelModifiers: { trim: true },
                maxlength: "100"
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.crossNavigationManagement.fixedValue')), 1)
            ]),
            _createVNode(_component_Button, {
              label: _ctx.$t('common.add'),
              onClick: _ctx.addFixedValue,
              class: "kn-button p-button-text"
            }, null, 8, ["label", "onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.navigation.fromPars)
        ? (_openBlock(), _createBlock(_component_Listbox, {
            key: 1,
            options: _ctx.navigation.fromPars
          }, {
            empty: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            option: _withId((slotProps) => [
              _createVNode("div", {
                class: "p-d-flex card p-p-3 kn-draggable",
                draggable: "true",
                onDragstart: ($event: any) => (_ctx.onDragStart($event, slotProps.option))
              }, [
                _hoisted_5,
                _createVNode("div", null, _toDisplayString(slotProps.option.name), 1),
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(_ctx.dialogDescriptor.parType[slotProps.option.type].label)), 1)
              ], 40, ["onDragstart"])
            ]),
            _: 1
          }, 8, ["options"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.crossNavigationManagement.availableInput')), 1)
        ]),
        _: 1
      }),
      (_ctx.navigation.toPars)
        ? (_openBlock(), _createBlock(_component_Listbox, {
            key: 0,
            options: _ctx.navigation.toPars
          }, {
            empty: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            option: _withId((slotProps) => [
              (slotProps.option.links && slotProps.option.links.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode("div", null, [
                      _createTextVNode(_toDisplayString(slotProps.option.links[0].name) + " ", 1),
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(slotProps.option.name), 1)
                    ]),
                    _createVNode("i", {
                      class: "fa fa-times-circle p-mr-2 p-ml-auto",
                      onClick: ($event: any) => (_ctx.removeLink(slotProps.option.id)),
                      "data-test": "remove"
                    }, null, 8, ["onClick"])
                  ]))
                : (_openBlock(), _createBlock("div", {
                    key: 1,
                    class: ["p-d-flex p-p-3 card", { dropzone: _ctx.dropzoneActive[slotProps.option.id] }],
                    onDrop: ($event: any) => (_ctx.link($event, slotProps.option)),
                    onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                    onDragleave: _withModifiers(($event: any) => (_ctx.setDropzoneClass(false, slotProps.option.id)), ["prevent"]),
                    onDragover: _withModifiers(($event: any) => (_ctx.setDropzoneClass(true, slotProps.option.id)), ["prevent"])
                  }, [
                    _createVNode("div", null, _toDisplayString(slotProps.option.name), 1),
                    _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t(_ctx.dialogDescriptor.parType[slotProps.option.type].label)), 1)
                  ], 42, ["onDrop", "onDragleave", "onDragover"]))
            ]),
            _: 1
          }, 8, ["options"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
})